/**
 * buildSocialShareProps
 *
 * Pure helper that maps a target `UserEntity` + a pre-computed
 * `ShareContent` into the props consumed by the social share sheet. Used
 * by the inline share handlers in the User Actions sheet and the
 * Subscribers empty state.
 */

import { UserUtils } from '@/domain/utils/userUtils';
import type { UserEntity } from '@/domain/entities/user/userEntity';
import type { ShareContent } from '@/domain/usecases/share/shareContent';
import type { ShareSocialContentProps } from '@/presentation/feature/content/components/sheets/shareSocial/components/ShareSocialContent';

export const buildSocialShareProps = (
  user: UserEntity,
  shareContent: ShareContent,
): ShareSocialContentProps => ({
  headerImageUrl: UserUtils.generateUserProfileImageUrl(user.firebaseId),
  headerImageAlt: `${user.firstName} ${user.lastName}`,
  shareTitle: shareContent.title,
  shareText: shareContent.text,
  shareUrl: shareContent.shareUrl,
});
